import {
  Box,
  Image,
  Avatar,
  Text,
  HStack,
} from "@chakra-ui/react";
import { Model } from "@/types/design";

type Props = {
  mode: Model;
};

const BaseModeItem = (props: Props) => {
  const { mode } = props;

  return (
    <Box
      position={"relative"}
    >
      <Image w="100%" h="240px" objectFit={"cover"} src={require(`/src/assets/design/contentstyles/${mode.background}`)} />
      <Box
        position="absolute"
        bottom="0"
        left="0"
        right="0"
        p="5px 10px"
        bg="linear-gradient(180deg, rgba(142, 148, 169, 0.2) 0%, #27314D 101%)"
        color="white"
        transition="all 0.3s"
      >
        <HStack mb="10px">
          <Avatar src="https://bit.ly/tioluwani-kolawole" w="20px" h="20px" />
          <Text fontSize="12px">{mode.username}</Text>
        </HStack>
        <Box mb="10px" fontSize="14px" fontWeight={"bold"}>
          {mode.name}-{mode.realname}
        </Box>
        <Box
          fontSize="12px"
          style={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2, // 限制为两行
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {mode.intro}
        </Box>
      </Box>
    </Box>
  );
};
export default BaseModeItem;
